import Main from '@/pages/Main';
const Management = () => {
    return (
        <div className="l-main l-main__content l-main__page-main-content" style={{ backgroundColor: '#fff' }}>
            <Main />
        </div>
    );
};

export default Management;
